import { useUserContext } from "@/contexts/UserContextProvider.tsx";
import MovieIcon from "@/assets/movie.svg";
import LongContentWrapper from "@/components/common/LongContentWrapper.tsx";
import ProfilePictureUpload from "./Account/ProfilePictureUpload";

const SettingsSheetProfile = () => {
  const { currentUser } = useUserContext();

  return (
    <>
      <div className="space-y-3 gap-3">
        <div className="flex gap-3 items-center">
          <ProfilePictureUpload />
          <div className="text-sm text-primary-foreground dark:text-white w-full">
            <h5 className="text-base font-medium">
              {currentUser?.firstName} {currentUser?.lastName}
            </h5>
            <p className="text-muted-foreground text-base w-9/10">
              <LongContentWrapper>{currentUser?.email}</LongContentWrapper>
            </p>
          </div>
        </div>
        <div className="flex gap-3 items-center">
          <div className="w-11 h-11 rounded-[10px] bg-accent flex items-center justify-center">
            <img src={MovieIcon} alt="movie" className="h-5 w-5" />
          </div>
          <div className="text-primary-foreground dark:text-white">
            <h5 className="text-base font-medium">
              {currentUser?.office?.company.profile.companyName}
            </h5>
            <p className="text-muted-foreground text-sm">
              {currentUser?.office?.name}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsSheetProfile;
